module.exports = __webpack_public_path__ + "img/固定预设.783ea497.jpg";